import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from './stage-header.styles';

export const StageHeader = () => {
  const { t } = useTranslation();

  return <Title>{t('stageTitle')}</Title>;
};
